import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// The web config keys are NOT secret — they are public identifiers.
// Security is enforced by Firestore rules, not by hiding these values.
// Values come from `frontend/.env` (see .env.example). In CRA, only vars
// prefixed with REACT_APP_ are exposed to the bundle.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebaseConfig.projectId) {
  // Don't crash the dev server before Firebase is wired up — just warn loudly.
  // eslint-disable-next-line no-console
  console.warn(
    '[firebaseConfig] Missing Firebase config. Copy frontend/.env.example to ' +
      'frontend/.env and fill in the REACT_APP_FIREBASE_* values.'
  );
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export default firebase;
